module.exports = __webpack_public_path__ + "media/images/vector-406f132b7f6aea206d6426449d8eef45.png";